import { http } from "./http";

export interface Driver {
  id: number;
  name: string;
  phone: string;
  email?: string | null;
  vehicle_type?: string | null;
  status: "ACTIVE" | "INACTIVE" | "SUSPENDED";
  has_password: boolean; 
  created_at?: string;
  updated_at?: string;
}

type ListParams = {
  status?: "ACTIVE" | "INACTIVE" | "SUSPENDED" | "ALL";
  q?: string;
};

// ✅ matches backend response + your page usage
export async function listDrivers(params?: ListParams): Promise<{ drivers: Driver[] }> {
  const res = await http.get("/api/admin/drivers", {
    params,
  });

  // backend returns { drivers: [...] }
  if (Array.isArray(res.data)) return { drivers: res.data };
  return { drivers: res.data?.drivers || [] };
}

export async function createDriver(payload: {
  name: string;
  email: string; // REQUIRED
  phone?: string | null;
  vehicle_type?: string | null;
  status?: "ACTIVE" | "INACTIVE" | "SUSPENDED";
}): Promise<Driver> {
  const res = await http.post("/api/admin/drivers", payload);
  return res.data?.driver || res.data;
}

export async function updateDriver(
  id: number,
  payload: Partial<{
    name: string;
    phone: string;
    email: string | null;
    vehicle_type: string | null;
    status: "ACTIVE" | "INACTIVE" | "SUSPENDED";
  }>
): Promise<Driver> {
  const res = await http.patch(`/api/admin/drivers/${id}`, payload);
  return res.data?.driver || res.data;
}

// soft delete → backend should set INACTIVE
export async function deactivateDriver(id: number): Promise<Driver> {
  const res = await http.delete(`/api/admin/drivers/${id}`);
  return res.data?.driver || res.data;
}

export async function reactivateDriver(id: number): Promise<Driver> {
  const res = await http.post(`/api/admin/drivers/${id}/reactivate`, {});
  return res.data.driver;
}

export async function deleteDriverHard(id: number): Promise<void> {
  await http.delete(`/api/admin/drivers/${id}/hard`);
}

export async function resendDriverInvite(id: number): Promise<void> {
  await http.post(`/api/admin/drivers/${id}/resend-invite`, {});
}